import React from 'react';
import Chart from 'react-apexcharts/dist/react-apexcharts.esm.js';
import { chartColors } from '../../styles/graphStyles';

const CustomGraph = ({ data, target }) => {
  const chartData = data.graphData.map((value, index) => ({
    x: index + 1,
    y: value
  }));

  const options = {
    chart: {
      type: 'line',
      height: 200,
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      }
    },
    stroke: {
      curve: 'smooth',
      width: 3,
      colors: [chartColors.actualLine]
    },
    markers: {
      size: 4,
      colors: [chartColors.actualLine],
      strokeColors: '#fff',
      strokeWidth: 1,
      hover: {
        size: 6
      }
    },
    xaxis: {
      type: 'numeric',
      min: 1,
      max: 31,
      tickAmount: 15,
      labels: {
        style: {
          colors: 'rgba(0,0,0,0.5)'
        },
        formatter: function(val) {
          return Math.floor(val);
        }
      },
      axisBorder: {
        color: 'rgba(0,0,0,0.1)'
      },
      axisTicks: {
        color: 'rgba(0,0,0,0.1)'
      }
    },
    yaxis: {
      labels: {
        style: {
          colors: 'rgba(0,0,0,0.5)'
        }
      },
      axisBorder: {
        color: 'rgba(0,0,0,0.1)'
      }
    },
    grid: {
      borderColor: 'rgba(0,0,0,0.1)',
      strokeDashArray: 3
    },
    tooltip: {
      custom: function({ series, seriesIndex, dataPointIndex, w }) {
        const value = series[seriesIndex][dataPointIndex];
        const day = dataPointIndex + 1;
        return `
          <div style="padding: 8px; background: rgba(255, 255, 255, 0.9); border: 1px solid #ccc; border-radius: 4px;">
            <div style="font-size: 11px;">Day: ${day}</div>
            <div style="font-size: 12.5px; font-weight: bold; color: #3f51b5;">Value: ${value.toFixed(2)}</div>
          </div>
        `;
      }
    },
    annotations: {
      yaxis: [{
        y: target,
        borderColor: '#3f51b5',
        strokeDashArray: 5,
        borderWidth: 2,
        label: {
          text: `Target: ${target}`,
          style: {
            color: '#fff',
            background: '#3f51b5'
          }
        }
      }]
    },
    colors: [chartColors.actualLine],
    fill: {
      type: 'solid',
      opacity: 1,
      colors: [chartColors.actualLine]
    }
  };

  const series = [{
    name: 'Value',
    data: chartData
  }];

  return (
    <div style={{ width: '100%', height: '200px' }}>
      <Chart
        options={options}
        series={series}
        type="line"
        height="100%"
      />
    </div>
  );
};

export default CustomGraph;